var StorageService = /** @class */ (function () {
    function StorageService(api) {
        var _this = this;
        this.fetchStorage = function (app) { return _this.API.get("/storage/".concat(app)); };
        this.createStorageItem = function (storageItem) { return _this.API.post('/storage', storageItem); };
        this.updateStorageItem = function (storageItem) {
            return _this.API.patch("/storage/".concat(storageItem === null || storageItem === void 0 ? void 0 : storageItem.app, "/").concat(storageItem === null || storageItem === void 0 ? void 0 : storageItem.id), storageItem);
        };
        this.deleteStorageItem = function (app, storageItem) {
            return _this.API.delete("/storage/".concat(app, "/").concat(storageItem));
        };
        this.API = api;
    }
    return StorageService;
}());
export { StorageService };
